<template>
  <b-navbar-nav class="navbar-nav-right ml-auto">
    <b-nav-item-dropdown right class="nav-profile" @hidden="onDropdownHidden">
      <template slot="button-content">
        <div class="navbar-profile">
          <img v-if="userPhoto" class="img-xs rounded-circle" :src="userPhoto" alt />
          <default-photo v-else width="40px"></default-photo>
          <p class="mb-0 d-none d-sm-block navbar-profile-name">
            {{ userName }}
          </p>
        </div>
      </template>
      <div v-if="!isLanguageSettings" class="preview-list">
        <b-dropdown-item disabled class="preview-item d-sm-none">
          <div class="preview-thumbnail">
            <img v-if="userPhoto" class="img-xs rounded-circle" :src="userPhoto" alt />
            <default-photo v-else width="40px"></default-photo>
          </div>
          <b-button-group class="preview-item-content">
            <p class="mb-0 navbar-profile-name text-muted pl-2">
              {{ userName }}
            </p>
          </b-button-group>
        </b-dropdown-item>
        <b-dropdown-item
          v-for="item in profileMenuItems"
          :key="item.title"
          :to="item.fouterTo"
          class="preview-item"
        >
          <div class="preview-icon">
            <svg-icon name="settings" size="26"></svg-icon>
          </div>
          <div class="preview-item-content">
            <p class="preview-subject ellipsis mb-0 pl-2">
              {{ item.title }}
            </p>
          </div>
        </b-dropdown-item>
        <div
          class="preview-item dropdown-item"
          @click.prevent.stop="isLanguageSettings = !isLanguageSettings"
        >
          <span class="preview-icon">
            <svg-icon name="globe" size="26"></svg-icon>
          </span>

          <div class="preview-item-content pr-5">
            <p class="preview-subject ellipsis mb-0 pl-2">
              {{ $t('languagesName') }}
            </p>
          </div>

          <span class="preview-icon">
            <svg-icon name="chevron-right" size="26"></svg-icon>
          </span>
        </div>
        <b-dropdown-item class="preview-item" @click="signout">
          <div class="preview-icon">
            <svg-icon name="log-out" size="26"></svg-icon>
          </div>
          <div class="preview-item-content">
            <p class="preview-subject ellipsis mb-0 pl-2">
              {{ $t('header.titles.logout') }}
            </p>
          </div>
        </b-dropdown-item>
      </div>
      <div v-else class="preview-list">
        <div
          class="preview-item dropdown-item"
          @click.prevent.stop="isLanguageSettings = !isLanguageSettings"
        >
          <div>
            <span class="preview-icon">
              <svg-icon name="chevron-left" size="26"></svg-icon>
            </span>
          </div>

          <div class="preview-item-content">
            <p class="preview-subject ellipsis mb-0 text-muted pl-2">
              {{ $t('header.titles.changeLanguage') }}
            </p>
          </div>
        </div>
        <b-dropdown-item
          v-for="language in languages"
          :key="language.language"
          class="preview-item space-between"
          @click="changeLocale(language.language)"
        >
          <div class="preview-item-content pl-5 pr-4">
            <p class="preview-subject ellipsis mb-0">
              {{ language.title }}
            </p>
          </div>
          <div class="preview-icon">
            <svg-icon v-if="isCurrentLocale(language.language)" name="check" size="26"></svg-icon>
          </div>
        </b-dropdown-item>
      </div>
    </b-nav-item-dropdown>
  </b-navbar-nav>
</template>

<script>
import DefaultPhoto from '@/assets/images/faces/user.svg';
import { i18n } from '@/plugins/i18n';
import { apolloClientClearCache } from '@/plugins/apollo';

export default {
  name: 'TheHeaderProfileDropdown',
  components: {
    DefaultPhoto,
  },
  data() {
    return {
      isLanguageSettings: false,
    };
  },
  computed: {
    languages() {
      return i18n.availableLocales.map((item) => {
        return {
          language: item,
          title: this.$t('languagesName', item),
        };
      });
    },
    profileMenuItems() {
      return [
        {
          title: this.$t('header.titles.settings'),
          iconClass: 'mdi mdi-settings text-success',
          fouterTo: '/settings/profile',
        },
      ];
    },
    userName() {
      return this.$store.getters.userName;
    },
    userPhoto() {
      return this.$store.getters.userPhoto;
    },
  },
  watch: {
    currentLanguage() {
      this.isLanguageSettings = false;
    },
  },
  methods: {
    onDropdownHidden() {
      this.isLanguageSettings = false;
    },
    isCurrentLocale(locale) {
      return i18n.locale == locale;
    },
    changeLocale(locale) {
      apolloClientClearCache();
      i18n.locale = locale;
      localStorage.setItem('userLocale', locale);
    },
    toggleSidebar: () => {
      document.querySelector('body').classList.toggle('sidebar-icon-only');
    },
    toggleMobileSidebar: () => {
      document.querySelector('#sidebar').classList.toggle('active');
    },
    signout() {
      this.$authCore.SignOut();
      this.$routerCore.GoToSignIn();
    },
  },
};
</script>

<style lang="scss" scoped></style>
